import {GdprStorageManager} from './gdpr';
import {DummyStorageManager} from './dummy';
import type {StorageManager} from './types';

/**
 * Singleton StorageManager for utility/service modules that don't have access
 * to React or Panel component context (e.g. api-client, i18n, zendesk).
 *
 * When to use each pattern:
 * - localStorageManager                         — utility modules, service files, non-component code
 * - useLocalStorageManager()                    — React function components (hook)
 * - this.getContext('localStorageManager')       — Panel components (context registry)
 */

export const localStorageManager: StorageManager =
  typeof window === `undefined` || process.env.NODE_ENV === `test`
    ? new DummyStorageManager()
    : new GdprStorageManager(window.localStorage);
